<script setup>
import { onMounted, ref, watch } from 'vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  total: Number,
})

const element = ref(null)

const emit = defineEmits(['timeline'])

onMounted(() => {
  emit(
    'timeline',
    gsapTimeline({ name: 'ForbiddenWordBalloon' })
      .startInvisible(element)
      .fromTo(element, { scale: 0 }, { scale: 1, duration: 0.36, ease: 'back.out(1.7)' })
      .to(element, {
        textContent: props.total,
        duration: 0.9,
        ease: 'power2.out',
        snap: { textContent: 1 },
      })
  )
})

watch(
  () => props.total,
  (newTotal) => {
    gsap.to(element, {
      value: newTotal,
      duration: 0.6,
      ease: 'power1.out',
      snap: { textContent: 1 },
    })
  }
)
</script>

<template>
  <div ref="element" class="forbidden-word-balloon leading-none text-center h-full" />
</template>

<style scoped>
.forbidden-word-balloon {
  background: url('../../../../assets/images/hvw-balloon.png');
  background-repeat: no-repeat;
  background-size: contain;
  aspect-ratio: 26/9;
  width: 94%;
  height: max-content;
  padding-right: 6%;
}
</style>
